import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { BreadcrumbsContainer2 } from '../TakeCourse/CourseHome.styles';
import UserHomeDataProvider from '../../Utils/Users/UserHomeDataProvider';
import EachQuestion from './EachQuestion/EachQuestionComponent.component';
import {
  QuizContainer,
  ButtonContainer,
  ButtonContainerFull,
} from './QuizPageStyles.styles';
import ErrorMessage from '../../Components/ErrorPage/Error.component';
import QuizSubmit from './QuizSubmitComponent.component';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import { AuthCheckUser } from '../../Utils/AuthCheck/UserCheck.auth';
import {
  CourseHomeRight,
  CouseHomeLeft,
} from '../TakeCourse/CourseHome.styles';
import { useQuery } from '@tanstack/react-query';
import { httpGetSingleCourse } from '../../Hooks/courses.hooks';
import SidebarQuestions from './SidebarQuestions.component';
import LoadingQuizPage from '../../Components/LoadingPages/LoadingQuiz.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import PageScroller from '../../Components/PageScroller/PageScroller.component';
import QuizHeader from './QuizHeader.component';

// Component for doing the quiz
const QuizComponent = () => {
  const { id } = useParams();
  const [answered, setAnswered] = useState(0);
  const [correct, setCorrect] = useState(0);
  const [answeredQuestions, setAnsweredQuestions] = useState({});
  const [userAnswers, setUserAnswers] = useState({});
  const { data, isLoading, isError } = useQuery({
    queryKey: ['course', id],
    queryFn: () => httpGetSingleCourse(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });

  // Always call hooks in the same order
  useEffect(() => {
    if (data?.quiz) {
      const savedAnswers = localStorage.getItem(`quizAnswers-${id}`);
      if (savedAnswers) {
        const parsedAnswers = JSON.parse(savedAnswers);
        setUserAnswers(parsedAnswers);
        const correctCount = calculateCorrectAnswers(
          parsedAnswers,
          data?.quiz || []
        );
        setCorrect(correctCount);
      }
    }
  }, [id, data?.quiz]);

  useEffect(() => {
    if (Object.keys(userAnswers).length > 0) {
      localStorage.setItem(`quizAnswers-${id}`, JSON.stringify(userAnswers));
    }
  }, [userAnswers, id]);

  useEffect(() => {
    if (data?.quiz) {
      const correctCount = calculateCorrectAnswers(userAnswers, data?.quiz);
      setCorrect(correctCount);
    }
  }, [userAnswers, data?.quiz]);

  const calculateCorrectAnswers = (userAnswers, quizData) => {
    let correctCount = 0;
    quizData?.forEach((question) => {
      if (userAnswers[question.id] === question?.correctAnswer) {
        correctCount++;
      }
    });
    return correctCount;
  };

  const quizLength = data?.quiz?.length;

  // Handle loading and error states without returning early
  if (isLoading) {
    return <LoadingQuizPage />;
  }

  if (isError) {
    return <ErrorMessage message="Could not get the quiz" />;
  }

  return (
    <AuthCheckUser>
      <HelmetHelper
        title={data?.courseName ? `${data?.courseName} Quiz ` : 'Quiz '}
        description="Take the quiz for the course"
      />
      <QuizContainer>
        <CourseHomeRight dissapear={true}>
          <BreadCrumbs
            one={data?.courseName}
            oneLink={`/course/home/${data?._id}`}
            two="Quiz"
          />
          <p>
            Questions Answered: {answered} / {quizLength}
          </p>
          <SidebarQuestions
            questions={data?.quiz}
            answeredQuestions={answeredQuestions}
          />
          <ButtonContainerFull>
            <QuizSubmit
              id={data?._id}
              correct={correct}
              length={quizLength}
              courseName={data?.courseName}
              course={data}
              answered={answered}
              userAnswers={userAnswers}
            />
          </ButtonContainerFull>
        </CourseHomeRight>
        <CouseHomeLeft>
          <BreadcrumbsContainer2>
            <BreadCrumbs
              one="My Dashboard"
              oneLink="/user"
              two={data?.courseName}
            />
          </BreadcrumbsContainer2>
          <QuizHeader courseName={data?.courseName} />
          {data.quiz?.map((q, i) => {
            return (
              <EachQuestion
                key={q.id}
                i={i}
                q={q}
                userAnswers={userAnswers}
                setCorrect={setCorrect}
                setAnswered={setAnswered}
                correct={correct}
                setAnsweredQuestions={setAnsweredQuestions}
                answeredQuestions={answeredQuestions}
                setUserAnswers={setUserAnswers}
              />
            );
          })}
          <PageScroller />
          <ButtonContainer>
            <UserHomeDataProvider>
              {(user) => (
                <QuizSubmit
                  id={data?._id}
                  correct={correct}
                  length={quizLength}
                  courseName={data?.courseName}
                  course={data}
                  answered={answered}
                  userAnswers={userAnswers}
                  user={user}
                />
              )}
            </UserHomeDataProvider>
          </ButtonContainer>
        </CouseHomeLeft>
      </QuizContainer>
    </AuthCheckUser>
  );
};

export default QuizComponent;
